import { TRANSFER_APPROVAL } from '../actionTypes';

export const fetchTransferRules = (action) => ({
  type: TRANSFER_APPROVAL.FETCH_TRANSFER_RULES,
  payload: action.payload,
});

export const setTransferApprovalRules = (action) => ({
  type: TRANSFER_APPROVAL.SET_TRANSFER_RULES,
  payload: action.payload,
});

export const fetchTeamMembers = (action) => ({
  type: TRANSFER_APPROVAL.FETCH_TEAM_MEMBERS,
  payload: action.payload,
});

export const addTransferApprovalRule = (action) => ({
  type: TRANSFER_APPROVAL.ADD_TRANSFER_APPROVAL_RULE,
  payload: action.payload,
});

export const deleteRule = (action) => ({
  type: TRANSFER_APPROVAL.DELETE_RULE,
  payload: action.payload,
});

export const setStatus = (action) => ({
  type: TRANSFER_APPROVAL.SET_STATUS,
  payload: action.payload,
});

export const fetchExistingRule = (action) => ({
  type: TRANSFER_APPROVAL.FETCH_EXISTING_RULE,
  payload: action.payload,
});
